export default Object.freeze({
  PERIOD: '기간',
  DOWNLOAD_LOG_FILE: '로그파일 다운로드',
});
